export enum PromotionPlanEnum {
  COMMISSION = 1,
  WELCOME = 2,
  FIRST_50 = 3,
  PROMOTION = 4,
  FIRST_300 = 5,
  BONUS = 6,
}
